'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdTune = function MdTune(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 15v-10h3.4v3.4h6.6v3.2h-6.6v3.4h-3.4z m10 6.6h-16.6v-3.2h16.6v3.2z m-23.4-6.6h3.4v10h-3.4v-3.4h-6.6v-3.2h6.6v-3.4z m10 20h-3.2v-10h3.2v3.4h13.4v3.2h-13.4v3.4z m-16.6-26.6h16.6v3.2h-16.6v-3.2z m0 20h10v3.2h-10v-3.2z' })
        )
    );
};

exports.default = MdTune;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/tune.js
// module id = 1566
// module chunks = 36573943044255 79611799117203 213534597649335